import React from 'react';
import { useField, ErrorMessage } from 'formik';
import classNames from 'classnames';
import DOMPurify from 'dompurify';

interface FormTextAreaFieldProps {
    fieldName: string;
    label: string;
    readOnly?: boolean;
    required?: boolean;
    small?: boolean;
    textAreaProps?: React.TextareaHTMLAttributes<HTMLTextAreaElement>;
    tooltipIconData?: {
        mainIcon: string;
        closeIcon: string;
    };
    tooltip?: string | null;
    renderTooltipTextAsHtml?: boolean;
}

export const FormTextAreaField: React.FC<FormTextAreaFieldProps> = ({
    fieldName,
    label,
    readOnly = false,
    required = false,
    small = false,
    textAreaProps = {},
    tooltipIconData,
    tooltip,
    renderTooltipTextAsHtml = false,
}) => {
    const [field, meta] = useField(fieldName);

    const showError = meta.touched && meta.error;
    const classnames = classNames('TextArea', { ViewOnly: readOnly });

    return (
        <div
            className={classNames('FormBox FormSideBySide', {
                FormFieldRequired: required,
            })}
        >
            <div className="FormLabel">
                <label htmlFor={fieldName}>{label}</label>
                {tooltip && tooltipIconData?.mainIcon && tooltipIconData?.closeIcon && (
                    <div className="FormTooltipContainer">
                        <div
                            className="TooltipIconContainer"
                            onClick={() => DOMPurify.sanitize(tooltip)}
                        >
                            <img
                                src={tooltipIconData.mainIcon}
                                alt="Tooltip icon"
                                className="TooltipMainIcon"
                            />
                        </div>
                    </div>
                )}
            </div>
            <div className="FormField">
                <textarea
                    id={fieldName}
                    {...field}
                    {...textAreaProps}
                    className={classnames}
                    readOnly={readOnly}
                />
                {showError && <div className="ErrorLabel">{meta.error}</div>}
            </div>
        </div>
    );
};
